// The predicate mirrors the `!!value` test exactly: `NonNullable<T>` would only drop
// `null`/`undefined` and leave the falsy literals (`false`, `''`, `0`) that `&&`-built arrays
// such as `[cond && row, …].filter(notEmptyValue)` are full of.
export const notEmptyValue = <T>(value: T): value is Exclude<T, null | undefined | false | 0 | ''> => {
    return !!value;
};
